/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
/* eslint-disable react/prefer-stateless-function */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
import React, { useState, useEffect,useCallback, useRef } from 'react';  
import MetaTags from 'react-meta-tags' 
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import Axios from 'axios'

export default function List_your_coin(){

  const [email_id, set_email_id] = useState("")
  const [coin_symbol, set_coin_symbol] = useState("")
  const [coin_name, set_coin_name] = useState("")
  const [official_forum_url, set_official_forum_url] = useState("")
  const [website_link, set_website_link] = useState("")
  const [twitter_username, set_twitter_username] = useState("")
  const [facebook_username, set_facebook_username] = useState("")
  const [coin_description, set_coin_description] = useState("")
  const [contract_address, set_contract_address] = useState("")
  const [genesis_date, set_genesis_date] = useState("")
  const [coin_image, set_coin_image] = useState("")
  const [bnb_wallet_address, set_bnb_wallet_address] = useState(localStorage.getItem("token_address")) 

  const [valid_email_id, set_valid_email_id] = useState<any>()
  const [valid_coin_symbol, set_valid_coin_symbol] = useState<any>()
  const [valid_coin_name, set_valid_coin_name] = useState<any>() 
  const [valid_coin_description, set_valid_coin_description] = useState<any>()
  const [valid_contract_address, set_valid_contract_address] = useState<any>() 
  const [valid_coin_image, set_valid_coin_image] = useState<any>() 
  const [valid_form, set_valid_form] = useState<any>() 
  const [valid_coin_id, set_valid_coin_id] = useState<any>()
  
  const [upImg, setUpImg] = useState<any>();
  const imgRef = useRef(null);
  const previewCanvasRef = useRef(null);
  const [crop, setCrop] = useState({ unit: '%', width: 30, aspect: 1 / 1 });
  const [completedCrop, setCompletedCrop] = useState(null);
  const [upload_image_message, set_upload_image_message] = useState("") 
  const [blobFile, set_blobFile] = useState<any>()  
  const [profile_img, set_profile_img] = useState("")  

  const SubmitDetails=()=>{  
     
    set_valid_email_id("")
    set_valid_coin_symbol("")
    set_valid_coin_name("")
    set_valid_coin_description("")
    set_valid_contract_address("")
    set_valid_coin_image("") 
    set_upload_image_message("")

    const reg_email = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{1,})$/i;
    const reg_coin_description= /^[a-zA-z0-9]{4,25}$/i;
    const reg_contract_address= /^[a-zA-z0-9]{20,50}$/i;
    const reg_coin_symbol= /^[a-zA-z_]{2,25}$/i;
    const reg_coin_name= /^[a-zA-z_ ]{4,25}$/i; 
    const reg_required= /^[a-zA-z0-9_-]{1,100}$/;

    if(bnb_wallet_address){
    if(email_id.length > 0){
      if(reg_email.test(email_id)){
          if(reg_required.test(coin_symbol)){
                if(reg_coin_symbol.test(coin_symbol)){
                    if(reg_required.test(coin_name)){
                       if(reg_coin_name.test(coin_name)){
                          if(reg_required.test(contract_address)){
                            if(reg_contract_address.test(contract_address)){ 
                                  if(reg_required.test(coin_description)){
                                    if(reg_coin_description.test(coin_description)){
                                      if(upImg == null){
                                        set_upload_image_message("Please select the image before upload")
                                     }
                                     else{
                                      onFileSave()
                                     }
                                    }
                                    else{
                                      set_valid_coin_description("The coin description must be at least 4 characters")
                                    } 
                                  }
                                  else{
                                    set_valid_coin_description("The coin description field is required")
                                  } 
                            }
                            else{
                              set_valid_contract_address("The contact address must be at least 20 characters")
                            }
                          }
                          else{
                            set_valid_contract_address("Contract address feild is required")
                          }
                       }
                       else{
                          set_valid_coin_name("The coin name must be at least 3 characters")
                       }
                    }
                    else{
                      set_valid_coin_name("Coin name feild is required")
                    }
                }
                else{
                  set_valid_coin_symbol("The coin symbol must be at least 2 characters") 
                }
          }
          else{
            set_valid_coin_symbol("Coin symbol feild is required")
          }
      }
      else{
        set_valid_email_id("Enter valid Email ID") 
      }
    }
    else{ 
      set_valid_email_id("Email ID feild is required")  
    }
  }
  else{
    set_valid_form("Please Connect to wallet")
  }
    
  }

  
  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setUpImg(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const onLoad = useCallback((img) => {
    imgRef.current = img;
  }, []);

  const onCropComplete = (crops) => {
    setCompletedCrop(crops)
    // if (!crops || !previewCanvasRef.current || !imgRef.current) {
    //     return;
    //   }  
  
      const image = imgRef.current;
    const canvas = previewCanvasRef.current;
      const crop = crops; 
  
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      const ctx = canvas.getContext('2d');
      const pixelRatio = window.devicePixelRatio;
  
      canvas.width = crop.width * pixelRatio;
      canvas.height = crop.height * pixelRatio;
  
      ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
      ctx.imageSmoothingQuality = 'high';
  
      ctx.drawImage(
        image,
        crop.x * scaleX,
        crop.y * scaleY,
        crop.width * scaleX,
        crop.height * scaleY,
        0,
        0,
        crop.width,
        crop.height
      );
      
      return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (!blob) { 
            return;
          }
          blob.name = 'newFile.jpeg';
          const fileUrl = window.URL.createObjectURL(blob);
          window.URL.revokeObjectURL(fileUrl);
          set_blobFile(blob) // Set blob image inside the state here 
          resolve(fileUrl);
        }, 'image/jpeg');
      }); 
  }; 

  
  const onFileSave = () =>{ 
 
        set_upload_image_message("") 

        const newImage = new File([blobFile], 'newFile.jpeg', { type: blobFile.type });
        const fd = new FormData(); 
        
        fd.append("coin_id", contract_address);
        fd.append("email_id", email_id);
        fd.append("coin_symbol", coin_symbol);
        fd.append("coin_name", coin_name);
        fd.append("official_forum_url", official_forum_url);
        fd.append("website_link", website_link);
        fd.append("twitter_username", twitter_username);
        fd.append("facebook_username", facebook_username);
        fd.append("coin_description", coin_description);
        fd.append("contract_address", contract_address);
        fd.append("genesis_date", genesis_date);
        fd.append("bnb_wallet_address", bnb_wallet_address); 
        fd.append("coin_image", (newImage.name, newImage));
        UploadProfileImage(fd);   
  }
  const UploadProfileImage =(image: any)=> { 

    console.log(image); 
      Axios({
        method: 'post',
      url: "https://api.arrano.network/tokens/create_new",
      data: image,
      headers: {'Content-Type': 'multipart/form-data', "X-API-KEY": "234ADSIUDG98669DKLDSFHDASDFLKHSDAFIUUUUS" },
     })
     .then(response => {  
       if(response.data.status){
          set_valid_form(response.data.message.alert_message)
       }
       else if(response.data.message.coin_id){ 
         set_valid_coin_id(response.data.message.coin_id)
       } 
       else if(response.data.message.email_id){
         set_valid_email_id(response.data.message.email_id)
       } 
       else if(response.data.message.coin_symbol){
         set_valid_coin_symbol(response.data.message.coin_symbol)
       } 
       else if(response.data.message.coin_name){
         set_valid_coin_name(response.data.message.coin_name)
       }  
       else if(response.data.message.coin_description){
         set_valid_coin_description(response.data.message.coin_description)
       } 
       else if(response.data.message.contract_address){
         set_valid_contract_address(response.data.message.contract_address)
       } 
       else if(response.data.message.coin_image){
         set_valid_coin_image(response.data.message.coin_image)
       }   
       else if(response.data.message.bnb_wallet_address){
         set_valid_form(response.data.message.bnb_wallet_address)
       }  
    })

    .catch(error=> console.log(error))

  }
 
    return (
      <> 
      <MetaTags>
        <title>Markets - Decentralized Exchange | DEX </title>
        <link rel="canonical" href="https://arrano.network/" />
        <meta name="description" content=" Arrano Network is a powerful and user-friendly decentralized exchange developed by the Arrano Developers community. Arrano DEX..." />
        <meta name="keyword" content="Arrano Network, Arrano DEX, ANO Token, Arrano Tokens, Arrano DeFi, Arrano airdrop , ANO Defi token , Arrano Network Community , Arrano Launchpad, Arrano Exchange Arrano Defi Project , ANO governance token" />
        <meta property="og:title" content="Markets - Decentralized Exchange | DEX" />
        <meta property="og:image" content="/bsc_logo.png" />
      </MetaTags> 
      <div id="Content" className="markets_list_page">
          <div className="container">
            <div className="main_block_list_coin">
              <div className="col-md-12">
                <h4 className="mt-3 market_title">List a Coin</h4>
                <p>List your coin here</p>
              </div>

              <div className="col-md-12">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Coin ID</label>
                        <input type="text" value={contract_address} className="form-control" id="coin_id" /> 
                        {valid_coin_id && <label>{valid_coin_id}</label>} 
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Email ID</label>
                        <input type="email" placeholder="Enter Email ID" value={email_id} onChange={(e)=> set_email_id(e.target.value)} className="form-control" id="email_id" />
                        {valid_email_id && <label>{valid_email_id}</label>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Contract Address</label>
                        <input type="text" placeholder="Enter Contract Address" value={contract_address} onChange={(e)=> set_contract_address(e.target.value)} className="form-control" id="email" />
                        {valid_contract_address && <label>{valid_contract_address}</label>}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Coin Name</label>
                        <input type="text" placeholder="Enter Coin Name" value={coin_name} onChange={(e)=> set_coin_name(e.target.value)} className="form-control" id="pwd" />
                        {valid_coin_name && <label>{valid_coin_name}</label>}
                     </div>
                    </div>
                    
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Symbol</label>
                        <input type="text" placeholder="Enter Symbol" value={coin_symbol} onChange={(e)=> set_coin_symbol(e.target.value)} className="form-control" id="pwd" />
                        {valid_coin_symbol && <label>{valid_coin_symbol}</label>}
                     </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Official forum url</label>
                        <input type="text" placeholder="Enter Official forum url" value={official_forum_url} onChange={(e)=> set_official_forum_url(e.target.value)} className="form-control" id="email" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Website Link</label>
                        <input type="text" placeholder="Enter Website Link" value={website_link} onChange={(e)=> set_website_link(e.target.value)} className="form-control" id="pwd" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Twitter Username</label>
                        <input type="text" placeholder="Enter Twitter Username" value={twitter_username} onChange={(e)=> set_twitter_username(e.target.value)} className="form-control" id="pwd" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Facebook Username</label>
                        <input type="text" placeholder="Enter Facebook Username" value={facebook_username} onChange={(e)=> set_facebook_username(e.target.value)} className="form-control" id="pwd" />
                      </div>
                    </div>
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label>Github</label>
                        <input type="password" className="form-control" id="pwd" />
                      </div>
                    </div> */}
                    {/* <div className="col-md-6">
                      <div className="form-group">
                        <label>Meta Keywords</label>
                        <input type="password" className="form-control" id="pwd" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Meta Contents</label>
                        <input type="password" className="form-control" id="pwd" />
                      </div>
                    </div> */}
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Coin Description</label>
                        <input type="text" placeholder="Enter Coin description" value={coin_description} onChange={(e)=> set_coin_description(e.target.value)} className="form-control" id="pwd" />
                        {valid_coin_description && <label>{valid_coin_description}</label>}
                     </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Genesis Date</label>
                        <input type="date" placeholder="Enter Genesis Date" value={genesis_date} onChange={(e)=> set_genesis_date(e.target.value)} className="form-control" id="pwd" />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>Coin Logo</label>
                        <input type="file" onChange={onSelectFile} className="form-control" id="email" />
                      </div>

                      {
                        upImg
                        ?
                        <canvas
                        ref={previewCanvasRef}
                        // Rounding is important so the canvas width and height matches/is a multiple for sharpness.
                        style={{
                            width: Math.round(completedCrop?.width ?? 0),
                            height: Math.round(completedCrop?.height ?? 0)
                        }}
                        />
                        :
                        null
                      } 
                      <ReactCrop
                          src={upImg}
                          onImageLoaded={onLoad}
                          crop={crop}
                          onChange={(c: any) => setCrop(c)}
                          onComplete={(c: any) => onCropComplete(c)}
                      />
                      {upload_image_message && <label>{upload_image_message}</label>}
                    </div>
                  </div>
                  <button type="button" onClick={()=>SubmitDetails()} className="btn btn-primary list_coin_btn">Submit</button>
                  {valid_form && <label>{valid_form}</label>}
                </form>
              </div>
            </div>
          </div>
        </div>
        </>
    ); 
} 
